import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.css'],
    standalone: false
})
export class CommentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
